export const UNDER_AGE_IMAGE_MAP = {
  QQ: 'https://image-1251917893.file.myqcloud.com/Esports/new/user/under-age-qq.png',
  WX: 'https://image-1251917893.file.myqcloud.com/Esports/new/user/under-age-wechat.png',
};
